<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>  
    <dx-popup *ngIf="crudPopupVisible"
        title="Defter Türü Arama"
        [resizeEnabled]="false"
        [hideOnOutsideClick]="false"
        [showCloseButton]="true"
        [(visible)]="crudPopupVisible"
        (onHiding)="closePopupAfter($event, sablonCmp)"
    >
            <dk-ctl-tem-defter-tur-arama
            [control]="control"
            (closePopup)="closePopupAfter($event, sablonCmp)"
            ></dk-ctl-tem-defter-tur-arama>
    </dx-popup>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
